// extracted by mini-css-extract-plugin
export var orderDetails = "_tm-2";
export var orderImage = "_tm-1";
export var orderMeta = "_tm-3";
export var orderSummary = "_tm-0";
export var rightArrow = "_tm-4";